// extracted by mini-css-extract-plugin
export default {"asset":"style_asset__BglDZ","item":"style_item__Tpp6U","name":"style_name__H4SpA","title":"style_title__V+Vxc"};